<div class="in-apropiere">
    <h3>&#206;n apropiere</h3>
    <div class="row">
        <div class="col-md-4" ng-repeat="item in ::ctrl.items track by $index">
            <span class="km">{{::item.distance}}</span>
            <h5><a href="javascript:void(0);" ng-click="ctrl.go(item)">{{::item.title}}</a></h5>
            <p>{{::item.description}}</p>
            <span class="program">{{::item.program}}</span>
            <a href="javascript:void(0);" class="btn btn-xs" ng-click="ctrl.go(item)">Vezi detalii</a>
        </div>
    </div>
</div>